import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: number;
  title: string;
  excerpt: string;
  cover: string;
  category: string;
  author: string;
  publishTime: string;
  readCount: string;
  tags: string[];
}

export default function ArticleCard({
  id,
  title,
  excerpt,
  cover,
  category,
  author,
  publishTime,
  readCount,
  tags,
}: ArticleCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group flex flex-col sm:flex-row gap-4 p-4 rounded-lg bg-background-50 hover:bg-background-100 transition-colors cursor-pointer border border-background-200/70"
    >
      <div className="relative w-full sm:w-48 h-32 rounded-lg overflow-hidden flex-shrink-0 bg-background-200">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          title={title}
        />
      </div>
      <div className="flex flex-col justify-between flex-1 min-w-0">
        <div>
          <div className="flex items-center gap-2 mb-1.5">
            <span className="px-2 py-0.5 rounded-md text-xs bg-accent-100 text-accent-700 whitespace-nowrap">
              {category}
            </span>
            {tags.slice(0, 1).map((tag) => (
              <span key={tag} className="text-xs text-foreground-500 whitespace-nowrap">
                #{tag}
              </span>
            ))}
          </div>
          <h3 className="text-base font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors mb-1.5">
            {title}
          </h3>
          <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
            {excerpt}
          </p>
        </div>
        <div className="flex items-center gap-3 text-xs text-foreground-500 mt-2 flex-wrap">
          <span>{author}</span>
          <span>{publishTime}</span>
          <span>{readCount} 阅读</span>
        </div>
      </div>
    </Link>
  );
}